import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import {
  fetchUserConversations,
  fetchConversationMessages,
  sendChatMessage,
  markConversationAsRead,
} from '../../../state/redux/actions/chatActions.js'
import {
  clearCurrentConversation,
  setCurrentConversation,
} from '../../../state/redux/slices/chatSlice.js'

const useChat = () => {
  const dispatch = useDispatch()

  const getUserConversations = useCallback(
    userId => {
      return dispatch(fetchUserConversations(userId))
    },
    [dispatch]
  )

  const getConversationMessages = useCallback(
    conversationId => {
      return dispatch(fetchConversationMessages(conversationId))
    },
    [dispatch]
  )

  const sendMessage = useCallback(
    (conversationId, message) => {
      return dispatch(sendChatMessage({ conversationId, message }))
    },
    [dispatch]
  )

  const markAsRead = useCallback(
    conversationId => {
      return dispatch(markConversationAsRead(conversationId))
    },
    [dispatch]
  )

  const clearConversation = useCallback(() => {
    dispatch(clearCurrentConversation())
  }, [dispatch])

  const selectConversation = useCallback(
    conversation => {
      dispatch(setCurrentConversation(conversation))
    },
    [dispatch]
  )

  return {
    getUserConversations,
    getConversationMessages,
    sendMessage,
    markAsRead,
    clearConversation,
    selectConversation,
  }
}

export default useChat
